import React from "react";

/**
 * Capexara AI mark — exact paths from the brand SVG asset (May 2026)
 *
 * The mark uses absolute coordinates from the source SVG, preserved 1:1
 * via a wrapping `<g transform="translate(-939 -1022)">` and a viewBox
 * sized to those bounds (5-459 horizontally, 2-417 vertically).
 *
 * Antenna stem #7F7F7F is identical in both light and dark modes
 * (per brand spec — "remaining as it is" for dark mode).
 */
export function Logo({ size = 40 }) {
  // viewBox aspect 464:420 ≈ 1.10
  const w = Math.round((size * 464) / 420);
  return (
    <svg
      width={w}
      height={size}
      viewBox="0 0 464 420"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Capexara AI mark"
      data-testid="capexara-logo-mark"
    >
      <g transform="translate(-939 -1022)">
        {/* Antenna stem */}
        <path d="M1171.5 1066.5 1171.5 1197.13" stroke="#7F7F7F" strokeWidth="6.875" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="8" fill="none" />
        {/* Steel-left prism */}
        <path d="M944 1302 1054 1261 1164 1302 1054 1343Z" fill="#4E95D9" />
        <path d="M1054 1343.1 1164 1302 1164 1397.9 1054 1439Z" fill="#163E64" />
        <path d="M944 1302 1054 1343.1 1054 1439 944 1397.9Z" fill="#A6CAEC" />
        {/* Steel-right prism */}
        <path d="M1178 1302 1288 1261 1398 1302 1288 1343Z" fill="#4E95D9" />
        <path d="M1288 1343.1 1398 1302 1398 1397.9 1288 1439Z" fill="#163E64" />
        <path d="M1178 1302 1288 1343.1 1288 1439 1178 1397.9Z" fill="#A6CAEC" />
        {/* Ember prism */}
        <path d="M1061 1153.5 1171 1112 1281 1153.5 1171 1195Z" fill="#E97132" />
        <path d="M1171 1195.1 1281 1154 1281 1249.9 1171 1291Z" fill="#C44F0F" />
        <path d="M1061 1154 1171 1195.1 1171 1291 1061 1249.9Z" fill="#F2AA84" />
        {/* Spark orb */}
        <circle cx="1171" cy="1045" r="21" fill="#F26B1F" />
      </g>
    </svg>
  );
}

export function LogoLockup() {
  return (
    <div className="logo-lockup" data-testid="capexara-logo-lockup">
      <Logo size={40} />
      <span className="logo-word">
        Cape<span className="logo-word-x">x</span>ara AI
      </span>
    </div>
  );
}
